import { Button, CircularProgress } from "@mui/material";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { sendAllResForm, getMuestraVigente } from "../../../../redux/actions/resolucion";
import { convertDateTimeToNet, convertDateToNet } from "../../../../util/datetime";
import { downloadFile } from "../../../../util/files";


const FinalizarFormularioButton = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const contratistas = useSelector((state) => state.resolucion.contratistas);
  const empresas = useSelector((state) => state.resolucion.empresas);
  const res81Data = useSelector((state) => state.resolucion.postResolucion);
  const idDependenciaEmpleador = useSelector((state) => state.resolucion.searchedEstablecimiento);
  const datosEstablecimiento = useSelector((state) => state.resolucion.datosEstablecimiento.data);
  const loadingPostAllRes = useSelector((state) => state.resolucion.postAllRes.loading);

  const postFinalCancerigenos = async () => {

    const trabajadoresConExposicion = res81Data.trabajadores.filter((trabajador) => trabajador.examenes && Object.keys(trabajador.examenes).length > 0);
    const trabajadoresCantidad = res81Data.cabecera.cantidadTrabajadoresAdministracion +
      res81Data.cabecera.cantidadTrabajadoresProduccion;

    if (trabajadoresCantidad !== res81Data.trabajadores.length) {
      toast.error("Existen discrepancias en la cantidad de trabajadores declarados en el formulario respecto a la lista de trabajadores detallados en el anexo Nominas. Verificar lo ingresado.");
      return;
    }

    if (!trabajadoresConExposicion || trabajadoresConExposicion.length === 0) {

      toast.error("Debe agregar al menos un trabajador expuesto a una sustancia antes de finalizar el formulario.");

      return;
    }

    let idMuestra = res81Data.cabecera?.idMuestraProgramaPrevencion;
    if (!idMuestra) {
      try {
        const muestraData = await dispatch(getMuestraVigente("RES81"));
        idMuestra = muestraData?.value?.idMuestraProgramaPrevencion ?? muestraData?.idMuestraProgramaPrevencion ?? muestraData?.data?.idMuestraProgramaPrevencion;
      } catch (err) {
        toast.error("Error al obtener la muestra vigente.");
        return;
      }
    }

    const idPresentacion = state.presentacion.idPresentacion415;

    let payload = {
      // Dependencia empleador
      idDependenciaEmpleador: idDependenciaEmpleador,
      ...(idMuestra && {
        idMuestraProgramaPrevencion: idMuestra
      }),
      ...(state?.idFormulario && {
        id: state?.idFormulario
      }),
      ...(idPresentacion && {
        idPresentacion415: idPresentacion
      }),
      // Cabecera
      totalTrabajadoresProduccion:
        res81Data.cabecera.cantidadTrabajadoresProduccion,
      totalTrabajadoresProduccionEventuales:
        res81Data.cabecera.cantidadTrabajadoresEventualesProduccion,
      totalTrabajadoresAdministracion:
        res81Data.cabecera.cantidadTrabajadoresAdministracion,
      totalTrabajadoresAdministracionEventuales:
        res81Data.cabecera.cantidadTrabajadoresEventualesAdministracion,
      permiteFumar: res81Data.cabecera.sePuedeFumar,
      poseeEspacioFumador: res81Data.cabecera.espacioParaFumar,
      idContactoEmpresa: res81Data.cabecera.contacto,
      idResponsableEmpresa: res81Data.cabecera.responsableEmpresa,
      idResponsableEmpresaML: res81Data.cabecera.responsableMedicina,
      idResponsableEmpresaSH: res81Data.cabecera.responsableSH,
      idEstablecimientoDeclaradoSRT: res81Data.cabecera.idEstablecimientoDeclaradoSRT,

      // Observaciones:

      observacionesGenerales: res81Data.observaciones.observacionesGenerales,
      descripcionActividad:
        res81Data.observaciones.descripcionActividadEstablecimiento,

      // Sustancias y puestos:

      sustancias: res81Data.sustancias.map((sustancia) => {
        const proveedoresYCompradores = [
          ...(sustancia.proveedores || []),
          ...(sustancia.compradores || []),
        ];

        let proveedoresCompradores = proveedoresYCompradores.map((proveedor) => ({
          ...(state?.idFormulario && {
            id: proveedor.idPrevForm,
          }),
          razonSocial: proveedor.razonSocial,
          cuit: proveedor.cuit,
          pais: proveedor.pais,
          esComprador: proveedor.esComprador,
          provincia: proveedor.provincia,
          localidad: proveedor.localidad,
          calle: proveedor.calle,
          nro: proveedor.numero,
          piso: proveedor.piso,
          departamento: proveedor.departamento,
          sinNro: false,
          codigoPostal: proveedor.codigoPostal,
          telefono: "",
          codigoSRT: proveedor.codigoSRT,
        }));

        let utilizaciones = sustancia.usos.map((uso) => ({
          ...(state?.idFormulario && {
            id: uso.idPrevForm,
          }),
          idUsoOrigen: uso.usos,
          idModoEmpleo: uso.modoEmpleo,
          codigoSRT: uso.codigoSRT,
        }));

        let estudios = sustancia.estudios.map((estudio) => ({
          ...(state?.idFormulario && {
            id: estudio.idPrevForm,
          }),
          idTipoEstudio: estudio.idTipoEstudio,
          cantidadFrecuencia: estudio.numeroFrecuencia,
          idFrecuenciaEstudio: estudio.frecuenciaEstudio,
          idMetodologiaEmpleada: estudio.idMetodologiaEmpleada,
          codigoSRT: estudio.codigoSRT,
        }));

        let equiposRadiologicos = sustancia.equiposRadiologicos.map(
          (equipoRadiologico) => ({
            ...(state?.idFormulario && {
              id: equipoRadiologico.equipoRadiologicoData.idPrevForm,
            }),
            idEquipoRadiologicoEstablecimiento:
              equipoRadiologico.equipoRadiologicoData.id,
            idEquipoRadiologicoSRT: equipoRadiologico.equipoRadiologicoData.idEquipoRadiologicoSRT,
            dosimetrias: equipoRadiologico.dosimetria.map((dosimetria) => ({
              ...(state?.idFormulario && {
                id: dosimetria.idPrevForm,
              }),
              idTipoDosimetria: dosimetria.tipoDosimetria,
              idMetodoDosimetria: dosimetria.metodoDosimetria,
              cantidadPersonal: dosimetria.cantidadPersonal,
              cuitResponsable: dosimetria.cuitResponsable,
              codigoSRT: dosimetria.codigoSRT,
            })),

            responsablesUso: equipoRadiologico.respUso.map((responsable) => ({
              ...(state?.idFormulario && {
                id: responsable.idPrevForm,
              }),
              numeroPermisoHabilitante: responsable.numeroPermisoHabilitante,
              matriculaProfesional: responsable.matriculaProfesional,
              numeroAutorizacionIndividual:
                responsable.numeroAutorizacionIndividual,
              cuitResponsable: responsable.cuitResponsable,
              fechaExpedicion: convertDateTimeToNet(
                responsable.fechaExpedicion
              ),
              fechaVencimiento: convertDateTimeToNet(
                responsable.fechaVencimiento
              ),
              codigoSRT: responsable.codigoSRT,
            })),

            responsablesInstalacion: equipoRadiologico.respInst.map(
              (responsable) => ({
                ...(state?.idFormulario && {
                  id: responsable.idPrevForm,
                }),
                numeroLicenciaHabilitante:
                  responsable.numeroLicenciaHabilitante,
                domicilioHabilitacion: responsable.domicilioHabilitacion,
                cuitResponsable: responsable.cuitResponsable,
                fechaExpedicion: convertDateTimeToNet(
                  responsable.fechaExpedicion
                ),
                fechaVencimiento: convertDateTimeToNet(
                  responsable.fechaVencimiento
                ),
                codigoSRT: responsable.codigoSRT,
              })
            ),
            encargadosProteccion: equipoRadiologico.protRad.map(
              (responsable) => ({
                ...(state?.idFormulario && {
                  id: responsable.idPrevForm,
                }),
                cuitResponsable: responsable.cuitResponsable,
                matriculaProfesional: responsable.matriculaProfesional,
                tituloProfesional: responsable.tituloProfesional,
                numeroHabilitacion: responsable.numeroHabilitacion,
                codigoSRT: responsable.codigoSRT,
              })
            ),
          })
        );

        let puestos = res81Data.puestos
          .filter((p) => p.sustancias?.includes(sustancia.id))
          .map((puesto) => {
            // Mapeo de puestos
            return {
              ...(state?.idFormulario && {
                id: puesto.idPrevForm,
              }),
              idPuestoEstablecimiento: puesto.puesto,
              descripcion: puesto.descripcionActividades,
              informaSobreRiesgos: puesto.informaRiesgos,
              capacitacionSobreRiesgos: puesto.poseeCapacitaciones,
              entregaElementosDeProteccion: puesto.entregaProteccion,
              licenciaEspecial: puesto.licenciasEspeciales,
              descripcionEstudios: puesto.descripcionEstudios,
              elementosProteccionPersonal: puesto.elementosDeProteccion.map(
                (elementoDeProteccion) => ({
                  ...(state?.idFormulario && {
                    id: elementoDeProteccion.idPrevForm,
                  }),
                  idElementoProteccionPersonal:
                    elementoDeProteccion.idElementoDeProteccion,
                  ...(elementoDeProteccion.idPrevForm && {
                    codigoSRT: elementoDeProteccion.codigoSRT,
                  }),
                })
              ),
              medidasPreventivas: puesto.medidasPreventivas.map(
                (medidaPreventiva) => ({
                  ...(state?.idFormulario && {
                    id: medidaPreventiva.idPrevForm,
                  }),
                  idMedidaPreventivaCancerigenos:
                    medidaPreventiva.idMedidaPreventiva,
                  ...(medidaPreventiva.idPrevForm && {
                    codigoSRT: medidaPreventiva.codigoSRT,
                  }),
                })
              ),
              codigoSRT: puesto.codigoSRT,
            };
          });

        return {
          ...(state?.idFormulario && {
            id: sustancia.idPrevForm,
          }),
          idSustancia: parseInt(sustancia.id),
          idAgenteCancerigeno: sustancia.sustancia.sustancia,
          nombreComercial: sustancia.sustancia.nombre,
          cantidad: parseFloat((sustancia.sustancia.cantidad ?? "0").toString().replace(",", ".")),
          idUnidadMedida: sustancia.sustancia.unidad,
          codigoSRT: sustancia.codigoSRT,
          proveedoresCompradores,
          utilizaciones,
          estudios,
          equiposRadiologicos,
          puestos,
        };
      }),
      // Trabajadores:
      trabajadores: res81Data.trabajadores.map((trabajador) => {
        // Obtener sustancias asociadas al puesto del trabajador desde P5
        const sustanciaIds = [
          ...new Set(
            res81Data.puestos
              .filter((p) => p.puesto === trabajador.idPuesto)
              .flatMap((p) => p.sustancias || [])
          ),
        ];

        // Construir sub-lista de sustancias con exámenes
        const sustanciasList = sustanciaIds.map((sustanciaId) => {
          const examData = trabajador?.examenes?.[sustanciaId] || {};
          const examenesMedicos = [];
          Object.keys(examData).forEach((idExamen) => {
            if (examData[idExamen]?.value) {
              examenesMedicos.push({
                ...(state?.idFormulario && {
                  id: examData[idExamen]?.idPrevForm,
                }),
                idTipoExamenMedico: parseInt(idExamen),
                idSustancia: parseInt(sustanciaId),
                idExamenDeclaradoSRT: examData[idExamen]?.idExamenDeclaradoSRT,
              });
            }
          });

          return {
            idSustancia: parseInt(sustanciaId),
            permanente: trabajador.permanente ?? true,
            fechaInicioContacto: convertDateToNet(examData.inicioContacto || trabajador.inicioContacto),
            fechaFinContacto: convertDateToNet(examData.finContacto || trabajador.finContacto),
            codigoActividadSRT: trabajador.codigoActividadSRT,
            examenesMedicos,
          };
        });

        return {
          ...(state?.idFormulario && {
            id: trabajador.idPrevForm,
          }),
          idNomina: trabajador.idTrabajador,
          fechaIngresoEmpresa: convertDateToNet(trabajador.fechaIngreso),
          idPuestoEstablecimiento: trabajador.idPuesto,
          idSectorEstablecimiento: trabajador.idSector,
          idUnidadTiempoAntiguedadSector: null,
          antiguedadSector: null,
          idUnidadTiempoAntiguedadEmpresa: null,
          antiguedadEmpresa: null,
          categoria: null,
          sinExposicion: sustanciasList.length === 0,
          codigoSRT: trabajador.codigoSRT,
          sustancias: sustanciasList,
        };
      }),

      // Contratistas:
      contratistas: contratistas.data.map((contratista) => ({
        ...(state?.idFormulario && {
          id: contratista.idPrevForm,
        }),
        cuit: contratista.cuit,
        actividad: contratista.ciiu,
        cantidadTrabajadores: contratista.cantidadEmpleados,
        idContratistaSRT: contratista.idContratistaSRT,
      })),

      // Empresas:
      empresasTercerizadas: empresas.data.map((contratista) => ({
        ...(state?.idFormulario && {
          id: contratista.idPrevForm,
        }),
        cuit: contratista.cuit,
        actividad: contratista.ciiu,
        cantidadTrabajadores: contratista.cantidadEmpleados,
        idEmpresaSRT: contratista.idEmpresaSRT,
      })),
    };

    const isWorkerIncomplete = (worker) => {
      if (!worker.idSector || !worker.idPuesto) return true;

      const maxInicioExposicion = moment().subtract(1, 'year').endOf('year');
      const fechasInicio = [
        worker?.inicioContacto,
        ...Object.values(worker?.examenes || {}).map((sub) => sub?.inicioContacto),
      ].filter(Boolean);

      const tieneInicioPosteriorLimite = fechasInicio.some((fecha) => {
        const m = moment(fecha);
        return m.isValid() && m.isAfter(maxInicioExposicion, 'day');
      });

      if (tieneInicioPosteriorLimite) return true;

      // worker.exposicion es true si NO posee exposición (sinExposicion)
      if (worker.exposicion) return false;

      const sustanciasIds = [
        ...new Set(
          res81Data.puestos
            .filter((p) => p.puesto === worker.idPuesto)
            .flatMap((p) => p.sustancias || [])
        ),
      ];

      if (sustanciasIds.length === 0) return false;

      // Todos los puestos expuestos deben tener informados los exámenes y fechas para cada sustancia
      return sustanciasIds.some((idSub) => {
        const subData = worker.examenes?.[idSub];
        return !subData || !subData.inicioContacto;
      });
    };

    if (res81Data.trabajadores.some(isWorkerIncomplete)) {
      toast.error("Existen trabajadores con datos incompletos o con formato erróneo.");
      return;
    }

    dispatch(sendAllResForm(payload)).then((res) => {
      // En caso de edicion el no hay pdf a descargar. Ya que se presento anteriormente
      if (res?.value?.fileName) downloadFile(res?.value?.data, res.value.fileName);

      toast.success("Formulario Resolución 81/19 enviado exitosamente");

      if (state?.presentacion) {
        const idPresentacion = state.presentacion.idPresentacion415;
        navigate(`/prevencion/resolucion-81/detalle/${idPresentacion}`, {
          state: {
            ...state.presentacion,
            skipUnsavedGuard: true,
          },
        });
      } else {
        navigate(`/prevencion/establecimientos/${idDependenciaEmpleador}`, {
          state: {
            ...datosEstablecimiento,
            idDependenciaEmpleador,
            skipUnsavedGuard: true,
          },
        });
      }
    });
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={() => postFinalCancerigenos()}
      disabled={loadingPostAllRes}
      startIcon={loadingPostAllRes ? <CircularProgress size={20} color="inherit" /> : null}
    >
      {loadingPostAllRes ? "Enviando..." : "Finalizar"}
    </Button>
  )
}

export default FinalizarFormularioButton;